/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FusionMelcoFusionModelsCustomProductListItem,
    FusionMelcoFusionModelsCustomProductListItemFromJSON,
    FusionMelcoFusionModelsCustomProductListItemFromJSONTyped,
    FusionMelcoFusionModelsCustomProductListItemToJSON,
    FusionMelcoModelsCustomWarning,
    FusionMelcoModelsCustomWarningFromJSON,
    FusionMelcoModelsCustomWarningFromJSONTyped,
    FusionMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItem
 */
export interface FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItem {
    /**
     * 
     * @type {Array<FusionMelcoFusionModelsCustomProductListItem>}
     * @memberof FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItem
     */
    list: Array<FusionMelcoFusionModelsCustomProductListItem>;
    /**
     * 
     * @type {Array<FusionMelcoModelsCustomWarning>}
     * @memberof FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItem
     */
    warning_list?: Array<FusionMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItem
     */
    total: number;
}

export function FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItemFromJSON(json: any): FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItem {
    return FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItemFromJSONTyped(json, false);
}

export function FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(FusionMelcoFusionModelsCustomProductListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(FusionMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItemToJSON(value?: FusionMelcoModelsGenericList1MelcoFusionModelsCustomProductListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(FusionMelcoFusionModelsCustomProductListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(FusionMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


